var _path, _path2, _path3, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDisplayPicture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 114,
    viewBox: "0 0 114 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_248_205)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57 0C88.5 0 114 25.5 114 57C114 88.5 88.5 114 57 114C25.5 114 0 88.5 0 57C0 25.5 25.5 0 57 0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.9999 7.3999C84.3999 7.3999 106.6 29.5999 106.6 56.9999C106.6 84.3999 84.3999 106.6 56.9999 106.6C29.5999 106.6 7.3999 84.3999 7.3999 56.9999C7.3999 29.5999 29.5999 7.3999 56.9999 7.3999Z",
    fill: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_248_205",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 7,
    width: 100,
    height: 100
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9999 7.3999C84.3999 7.3999 106.6 29.5999 106.6 56.9999C106.6 84.3999 84.3999 106.6 56.9999 106.6C29.5999 106.6 7.3999 84.3999 7.3999 56.9999C7.3999 29.5999 29.5999 7.3999 56.9999 7.3999Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_248_205)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.7999 46L37.8999 46.2C35.4999 47 37.5999 52.4 37.5999 52.7C38.4999 57 38.0999 58.7 40.9999 58.8C40.9999 62.1 41.5999 64.9 43.0999 67C43.9999 68.4 44.4999 68.4 44.5999 70.7C44.5999 72.4 44.5999 74.2 44.4999 75.8C44.3999 78.2 44.5999 78.2 42.9999 79.4C35.8999 85.1 27.9999 85.3 17.8999 90.3C15.1999 91.7 14.4999 92.7 13.1999 95.9C12.5999 97.4 10.8999 105.1 10.8999 106.7H103.1C103 104.9 101.4 97.5 100.8 96C99.5999 93 98.9999 91.7 96.1999 90.3C85.2999 84.8 79.4999 85.7 71.0999 79.5C69.6999 78.5 69.5999 78.2 69.3999 76C69.2999 74.3 69.1999 72.6 69.2999 70.9C69.2999 68.1 69.4999 68.7 70.6999 67C72.1999 64.7 72.7999 62.1 72.8999 58.7C75.7999 58.6 75.2999 57.5 76.2999 52.6C76.2999 52.4 78.2999 47 76.1999 46.1L75.0999 46C75.4999 43.6 76.0999 42.2 76.1999 39.3C76.2999 36.7 76.6999 34.5 76.5999 31.9C76.4999 29.8 76.1999 26.9 75.5999 25.1C74.5999 22.3 73.3999 22.1 71.6999 21.3C71.7999 20.7 72.0999 20.8 72.2999 20.2C70.3999 19.9 69.8999 20 68.0999 20.4C67.7999 19.1 67.3999 18.4 66.4999 17.9C65.9999 17.6 65.5999 17.5 64.8999 17.4C63.6999 17.1 64.4999 17.3 63.7999 16.5C61.6999 17.4 62.6999 16.7 61.0999 16.6C59.2999 16.5 59.4999 16.9 57.5999 16.3C52.8999 14.9 51.1999 17.3 50.3999 17.5C49.9999 17.6 49.1999 17.6 48.7999 17.7C48.2999 17.8 47.7999 17.8 47.2999 18.1C46.4999 18.5 46.7999 18.6 46.2999 19.1C46.1999 19.2 44.9999 19.7 43.9999 20.4C41.9999 21.8 41.1999 23.3 40.2999 24.1C38.5999 25.7 37.8999 30.2 37.6999 32.6C37.3999 35.1 37.5999 37.4 37.5999 39.9C37.7999 42.6 38.3999 43.6 38.7999 46Z",
    fill: "#808080"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_248_205"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 114,
    height: 114,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisplayPicture);
export default __webpack_public_path__ + "static/media/DisplayPicture.33bc1a77a6a9b74dd39995e291d97be7.svg";
export { ForwardRef as ReactComponent };